// ---------------------------------------     Klarna payment     --------------------------------------- //
const finance = (t, e, n, r, i) => {
  var o,
    a,
    s,
    u = e / 12 / 100;
  return (
    r
      ? 1 === r && ((o = c(n)), (a = Math.pow(1 + u, n) - 1))
      : ((o = c(12 * n)), (a = Math.pow(1 + u, 12 * n) - 1)),
    (s = t * (o / a)),
    Math.round(100 * s) / 100
  );

  function c(t) {
    return (i && (t -= 1), u * Math.pow(1 + u, t));
  }
};

const formatMoney = (t, e) => {
  "string" == typeof t && (t = t.replace(".", ""));
  var n = "",
    r = /\{\{\s*(\w+)\s*\}\}/,
    i = e || "${{amount}}";

  function o(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
    if (isNaN(t) || null == t) return 0;
    var i = (t = (t / 100).toFixed(e)).split("."),
      o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
      a = i[1] ? r + i[1] : "";
    return o + a;
  }
  switch (i.match(r)[1]) {
    case "amount":
      n = o(t, 2);
      break;
    case "amount_no_decimals":
      n = o(t, 0);
      break;
    case "amount_with_comma_separator":
      n = o(t, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      n = o(t, 0, ".", ",");
  }
  return i.replace(r, n);
};

const addFinanceCalculations = () => {
  const selectors = {
    productFinanceContainer: "[data-finance-container]",
    productPrice: "[data-product-price]",
    financeMonthly: "[data-finance-monthly]",
  };

  let settings = {
    debug: false,
    minimumValue: 0,
    financeType: 1,
  };

  settings.minimumValue = theme.finance.minimumValue * 100;
  let productFinanceContainers = document.querySelectorAll(
    selectors.productFinanceContainer,
  );

  if (!productFinanceContainers) return;

  productFinanceContainers.forEach((el_productFinanceContainer) => {
    if (!el_productFinanceContainer) return;

    let el_productPrice =
        el_productFinanceContainer.querySelector(selectors.productPrice) ||
        el_productFinanceContainer,
      el_financeMonthly = el_productFinanceContainer.querySelector(
        selectors.financeMonthly,
      );

    if (!el_productPrice || !el_financeMonthly) return;

    let price = parseInt(el_productPrice.dataset.productPrice);

    let financeDepositAmount = theme.finance.depositPercent
      ? price / theme.finance.depositPercent
      : 0;
    var financeAmount = price - financeDepositAmount;

    if (settings.debug)
      console.log("Finance calculated", {
        productPrice: price,
        financeAmount: financeAmount,
      });

    if (price >= settings.minimumValue) {
      const result = finance(
        financeAmount,
        theme.finance.rate,
        theme.finance.numberOfPayments,
        settings.financeType,
      );
      el_financeMonthly.textContent = formatMoney(result, theme.moneyFormat);
      el_productFinanceContainer.removeAttribute("hidden");

      if (el_productFinanceContainer.parentElement) {
        // Remove class from parent div of `el_productFinanceContainer` in case it was added previously when price was lower than minimum value
        el_productFinanceContainer.parentElement.classList.remove(
          "finance-not-available",
        );
      }
    } else {
      el_productFinanceContainer.hidden = true;

      if (el_productFinanceContainer.parentElement) {
        // Add class to parent div of `el_productFinanceContainer` to control styling when finance option is not available due to price being lower than minimum value
        el_productFinanceContainer.parentElement.classList.add(
          "finance-not-available",
        );
      }
    }
  });
};

addFinanceCalculations();
